import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=50e868f2&scoped=true"
import script from "./imprint.vue?vue&type=script&lang=js"
export * from "./imprint.vue?vue&type=script&lang=js"
import style0 from "./imprint.vue?vue&type=style&index=0&id=50e868f2&prod&scoped=true&lang=css"
import style1 from "./imprint.vue?vue&type=style&index=1&id=50e868f2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e868f2",
  null
  
)

export default component.exports